import React from 'react';
import Icon from '../../../components/AppIcon';

const PriorityAlertsPanel = () => {
  const alerts = [
    {
      id: 1,
      title: 'Critical: Exposed Electrical Wiring',
      location: 'Plant 2 - Storage Area',
      daysOverdue: 5,
      severity: 'Critical'
    },
    {
      id: 2,
      title: 'High: Missing Safety Guards',
      location: 'Plant 1 - Assembly Line',
      daysOverdue: 3,
      severity: 'High'
    },
    {
      id: 3,
      title: 'High: Blocked Emergency Exit',
      location: 'Warehouse 1',
      daysOverdue: 2,
      severity: 'High'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Priority Alerts</h3>
        <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div>
      </div>
      
      <div className="space-y-4">
        {alerts?.map((alert) => (
          <div key={alert?.id} className="border border-border rounded-lg p-4 hover:bg-muted/30 transition-colors">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-red-500/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="AlertTriangle" size={18} className="text-red-500" />
                </div>
                <div>
                  <h4 className="text-sm font-medium text-foreground mb-1">{alert?.title}</h4>
                  <p className="text-xs text-muted-foreground">{alert?.location}</p>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mt-3">
              <span className="text-xs text-red-500 font-medium">
                {alert?.daysOverdue} days overdue
              </span>
              <button className="text-xs text-primary hover:text-primary/80 transition-colors">
                View Details →
              </button>
            </div>
          </div>
        ))}
      </div>

      <button className="w-full mt-4 py-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors">
        View All Alerts
      </button>
    </div>
  );
};

export default PriorityAlertsPanel;